import { ClientDto } from '@act/shared/data-transfer-objects';
import { ColumnConfiguration } from '@act/storybook';
import { Button } from '@mui/material';

export const CustomerTableColumns = ({
  openCustomerDetails,
}: {
  openCustomerDetails: (client: ClientDto) => void;
}): ColumnConfiguration<ClientDto>[] => [
  {
    id: 'name',
    value: 'name',
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Name',
    noWrap: true,
  },
  {
    id: 'displayName',
    value: 'displayName',
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Display Name',
    noWrap: true,
  },
  {
    id: 'avonMedicalCenterId',
    value: client => (client.avonMedicalCenterId ? 'BH Customer' : 'CG Only'),
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Customer Type',
    noWrap: true,
  },
  {
    id: 'clientMarketNumbers',
    value: client => {
      const marketNumber = client.clientMarketNumbers.find(
        number => number.type === 'phoneNumber'
      );
      const feedbackNumber = client.clientMarketNumbers.find(
        number => number.type === 'feedbackNumber'
      );

      const issues = [
        !client.name ? 'Missing Name' : null,
        !client.displayName ? 'Missing Display Name' : null,
        !marketNumber ? 'Missing Market Numbers' : null,
        !feedbackNumber ? 'Missing Feedback Numbers' : null,
        !client.reemaWebsite ? 'Missing Reema Website' : null,
        !client.reemaWebsite ? 'Missing Reema Website' : null,
      ].filter(v => !!v);
      return issues.length > 0 ? (
        <span style={{ color: 'red' }}>❌ {issues.join(', ')}</span>
      ) : (
        '✅'
      );
    },
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Is Valid',
  },
  {
    id: 'hasADTFeed',
    value: client => (client.hasADTFeed ? 'Yes' : 'No'),
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Has ADT Feed',
    noWrap: true,
  },
  {
    id: 'id',
    value: client => (
      <Button
        style={{ whiteSpace: 'nowrap' }}
        variant="outlined"
        onClick={e => {
          e.stopPropagation();
          openCustomerDetails(client);
        }}
      >
        View Details
      </Button>
    ),
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: false,
    title: '',
  },
];
